/**
 * Reads the three `VITE_*` values from env-reference.md and fails at boot with the missing names,
 * instead of rendering a dashboard that 401s on every call.
 */
export type WebConfig = {
  apiBaseUrl: string
  clerkPublishableKey: string
  appEnv: string
}

export function readConfig(env: Record<string, string | undefined>): WebConfig {
  const missing = ['VITE_API_BASE_URL', 'VITE_CLERK_PUBLISHABLE_KEY'].filter((key) => !env[key])
  if (missing.length > 0) {
    throw new Error(`Missing web configuration: ${missing.join(', ')}. Copy .env.example first.`)
  }

  return {
    apiBaseUrl: env.VITE_API_BASE_URL as string,
    clerkPublishableKey: env.VITE_CLERK_PUBLISHABLE_KEY as string,
    appEnv: env.VITE_APP_ENV ?? 'development',
  }
}
